import axios from '../../../services/axios';
import * as types from '../types';

const initialState = {
  isLoggedIn: false,
  token: null,
  user: {},
  authChecked: false,
};

export default function auth(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOGIN_SUCCESS: {
      return {
        ...state,
        isLoggedIn: true,
        token: action.payload.token,
        user: action.payload.user,
        authChecked: true,
      };
    }

    case types.LOGIN_FAILURE: {
      delete axios.defaults.headers.Authorization;

      return {
        ...state,
        isLoggedIn: false,
        token: null,
        user: {},
        authChecked: true,
      };
    }
    case types.AUTH_BOOTSTRAP_FINISHED:
      return {
        ...state,
        authChecked: true,
      };

    case types.PERSIST_REHYDRATE: {
      const incoming = action.payload?.auth;

      if (!incoming || !incoming.token) {
        return {
          ...state,
          authChecked: true,
        };
      }

      return {
        ...state,
        ...incoming,
        isLoggedIn: true,
        authChecked: true,
      };
    }

    default:
      return state;
  }
}
